import type { ComponentProps } from 'react';

import type { FieldLayoutOptions } from './useFieldLayout';
import { FormDateInput } from './FormField';
import { useFieldLayout } from './useFieldLayout';

type DateFieldProps = Omit<
  ComponentProps<typeof FormDateInput>,
  'label' | 'inputHeight' | 'inputBackground'
> &
  FieldLayoutOptions;

export const DateField = ({ label, hideLabel, ...fieldProps }: DateFieldProps) => {
  const field = useFieldLayout({ label, hideLabel });

  return (
    <FormDateInput
      label={field.label}
      aria-label={field.ariaLabel}
      inputHeight={field.inputHeight}
      inputBackground={field.inputBackground}
      {...fieldProps}
    />
  );
};
